import { Dayjs } from 'dayjs';
import { Decimal } from '@/models/decimal';

export type PossibleAvailableValues = number | string | Dayjs | Decimal | undefined;

export function isValueAvailable(value: PossibleAvailableValues): boolean {
  return value !== null && value !== undefined && (typeof value !== 'string' || value.trim().length > 0);
}
